<template>
  <client-only>
    <div class="full-page-wrapper">
      <the-header :relative="true"></the-header>
      <div class="flex flex-col md:flex-row rest-of-the-page text-black terms">
        <div class="w-full md:w-1/2 bg-white relative">
          <div class="tabs-container">
            <div class="tab-title z2"
                :class="{selected: selected.id === item.id}"
                v-for="item in items"
                :key="item.id"
                @click="handleSelection(item)">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2 content-container">
          <div class="tab-content z2">
            <privacy-policy v-if="selected.id === 'privacy'"></privacy-policy>
            <terms-policy v-else-if="selected.id === 'terms'"></terms-policy>
            <copyright-policy v-else-if="selected.id === 'copyright'"></copyright-policy>
            <clarification-policy v-else-if="selected.id === 'clarification'"></clarification-policy>
            <cookie-policy v-else-if="selected.id === 'cookie'"></cookie-policy>
          </div>
        </div>
      </div>
      <the-footer></the-footer>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import {ref, reactive, computed, onMounted} from 'vue';
import TheHeader from '~/components/core/TheHeader.vue';
import TheFooter from '~/components/core/TheFooter.vue';
import {useRoute} from "vue-router";
import TermsPolicy from "~/components/privacy/TermsPolicy.vue";
import CopyrightPolicy from "~/components/privacy/CopyrightPolicy.vue";
import ClarificationPolicy from "~/components/privacy/ClarificationPolicy.vue";
import CookiePolicy from "~/components/privacy/CookiePolicy.vue";
const route = useRoute();
const termsId = computed(() => parseInt(route.query.id as string));
const items = reactive([
  {
    id: 'privacy',
    title: 'Privacy Policy',
  },
  {
    id: 'terms',
    title: 'Terms and Conditions'
  },
  {
    id: 'copyright',
    title: 'Copyright & Trademark'
  },
  {
    id: 'clarification',
    title: 'Clarification Text'
  },
  {
    id: 'cookie',
    title: 'Cookie Policy'
  }
]);

const selected = ref(items[0]);

function handleSelection(item: any) {
  selected.value = item;
}
watch(() => route.path, () => {
  const termIndex = termsId.value || "0";
  selected.value = items[termIndex];
}, {immediate: true, deep: true});
onMounted(() => {
  const termIndex = termsId.value || "0";
  selected.value = items[termIndex];
})
</script>

<style scoped>
.tab-title span {
  display: inline-block;
  vertical-align: bottom;
  box-sizing: border-box;
  border-color: transparent;
  border-bottom: 3px;
  line-height: 0.8;
  transition: all ease 0.2s;
}
.tab-title.selected span {
  border-bottom: 2px;
  border-style: solid;
}
.terms {
  border-top: 1px solid #b8b8b8;
  border-bottom: 1px solid #b8b8b8;
}
.terms > div:first-child {
  border-right: 0;
  padding: 15px;
  border-bottom: 1px solid #b8b8b8;
}
@media (min-width: 768px) {
  .terms > div:first-child {
    border-right: 1px solid #b8b8b8;
    border-bottom: 0;
    padding: 25px 37px;
  }
}
.tabs-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}
@media (min-width: 768px) {
  .tabs-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: flex-start;
  }
}
.content-container {
  max-height: 70vh;
  overflow-y: auto;
}
@media (min-width: 768px) {
  .content-container {
    max-height: none;
    overflow-y: visible;
  }
}
.tab-title {
  cursor: pointer;
  margin: 0 5px;
}
@media (max-width: 767px) {
  .tab-title {
    font-size: 0.9rem;
    text-align: left;
  }
  .tabs-container {
    justify-content: flex-start;
  }
}
@media (min-width: 768px) {
  .tab-title {
    margin: 0;
  }
}
</style>
